"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var defaultPrefix = "ezd-portal";
var kebabRegexp = /([a-z]|\s+)([A-Z])/g;
var kebabCase = function (string, delimiter) {
    if (string === void 0) { string = ''; }
    if (delimiter === void 0) { delimiter = '-'; }
    return string.replace(kebabRegexp, "$1" + delimiter + "$2").toLowerCase();
};
var makeCssClass = function (prefix, ruleName) {
    if (prefix === void 0) { prefix = defaultPrefix; }
    if (ruleName === void 0) { ruleName = null; }
    return function (rule, sheet) {
        var _a, _b;
        //don't prefix mui components.
        var isMui = (_b = (_a = sheet === null || sheet === void 0 ? void 0 : sheet.options) === null || _a === void 0 ? void 0 : _a.name) === null || _b === void 0 ? void 0 : _b.startsWith('Mui');
        var block = kebabCase(ruleName || sheet.options.name);
        var element = kebabCase(rule.key).replace(block + "-", '');
        if (!element || block === element) {
            element = 'root';
        }
        return "" + (isMui ? '' : prefix + "_") + block + "_" + element;
    };
};
exports.default = makeCssClass;
//# sourceMappingURL=makeCssClass.js.map